angular.module('zc.zenclerkS')
  .component('zcsAgencySitesUserActivity', {
    templateUrl: '/templates/zenclerk_s/agencies/sites_user_activity/sites_user_activity.html',
    bindings: {
      agency: '<'
    },
    controller: zcsAgencySitesUserActivity,
  });

zcsAgencySitesUserActivity.$inject = ['$scope', '$stateParams', 'AgencyProject'];
function zcsAgencySitesUserActivity($scope, $stateParams, AgencyProject) {
  const vm = this;

  vm.$onInit = () => {
    AgencyProject.all($stateParams.agencyName)
      .then(projects => {
        vm.allProjects = projects;
        filterProjects();
      });

  };

  function filterProjects() {
    vm.projects = _.chain(vm.allProjects)
      .reject(d => d.is_test || d.is_demo)
      .sortBy(d => -new Date(d.created_at))
      .value();
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites_user_activity/sites_user_activity.component.js